/**
 * Pure geometry for the progress-split-bar HUD (CP21 "What to build" #5 /
 * acceptance criterion 6: "HUD split bar matches the loaded fixture's
 * `sharePct` values exactly"). Kept out of `HudScene.ts` so it's
 * unit-testable without Phaser/canvas - the scene only turns this into
 * rectangles.
 */
export interface SplitBarLayout {
  beorningsPct: number;
  lothwenPct: number;
  beorningsWidthPx: number;
  lothwenWidthPx: number;
}

export function computeSplitBarLayout(
  beorningsSharePct: number,
  lothwenSharePct: number,
  totalWidthPx: number,
): SplitBarLayout {
  return {
    beorningsPct: beorningsSharePct,
    lothwenPct: lothwenSharePct,
    beorningsWidthPx: (beorningsSharePct / 100) * totalWidthPx,
    lothwenWidthPx: (lothwenSharePct / 100) * totalWidthPx,
  };
}
